"use strict";

var _objectWithoutProperties = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _classCallCheck = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _ = _interopRequireWildcard(require("../"));

var _gsap = _interopRequireDefault(require("gsap"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/AniLink/Cover.js";

var Cover = /*#__PURE__*/function (_react$Component) {
  _inherits(Cover, _react$Component);

  var _super = _createSuper(Cover);

  function Cover(_props) {
    var _this;

    _classCallCheck(this, Cover);

    _this = _super.call(this, _props);

    _this.getCoverEl = function () {
      return document.querySelector(".tl-cover-el");
    };

    _this.horizontal = function (_ref) {
      var node = _ref.node,
          seconds = _ref.props.length,
          direction = _ref.direction;
      var directionTo = direction === 'left' ? '-100%' : '100%';
      var directionFrom = direction === 'left' ? '100%' : '-100%';
      var wait = seconds / 6;
      var half = (seconds - wait) / 2;

      var cover = _this.getCoverEl();

      return _gsap.default.timeline().set(cover, {
        y: 0,
        x: directionFrom,
        display: "block"
      }).to(cover, {
        x: "0%",
        ease: "power1.easeInOut",
        duration: half
      }).set(node, {
        opacity: 0
      }).to(cover, {
        x: directionTo,
        ease: "power1.easeInOut",
        duration: half
      }, "+=".concat(wait));
    };

    _this.vertical = function (_ref2) {
      var node = _ref2.node,
          seconds = _ref2.props.length,
          direction = _ref2.direction;
      var directionTo = direction === 'up' ? '-100%' : '100%';
      var directionFrom = direction === 'up' ? '100%' : '-100%';
      var wait = seconds / 6;
      var half = (seconds - wait) / 2;

      var cover = _this.getCoverEl();

      return _gsap.default.timeline().set(cover, {
        y: directionFrom
      }).to(cover, {
        y: "0%",
        ease: "power1.easeInOut",
        duration: half
      }).set(node, {
        opacity: 0
      }).to(cover, {
        y: directionTo,
        ease: "power1.easeIn",
        duration: half
      }, "+=".concat(wait));
    };

    _this.moveInDirection = function (_ref3) {
      var props = _ref3.props,
          direction = _ref3.direction,
          node = _ref3.node;

      if (direction === 'left' || direction === 'right') {
        return _this.horizontal({
          props: props,
          direction: direction,
          node: node
        });
      }

      return _this.vertical({
        props: props,
        direction: direction,
        node: node
      });
    };

    _this.horizontal = _this.horizontal.bind(_assertThisInitialized(_this));
    _this.vertical = _this.vertical.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Cover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var direction = this.props.direction || 'left';
      var length = this.props.duration || 1;

      var _this$props = this.props,
          removedExit = _this$props.exit,
          removedEntry = _this$props.entry,
          removedProp = _this$props.cover,
          props = _objectWithoutProperties(_this$props, ["exit", "entry", "cover"]);

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.default, (0, _extends2.default)({
        exit: {
          length: length,
          trigger: function trigger(_ref4) {
            var exit = _ref4.exit,
                node = _ref4.node;
            return _this2.moveInDirection({
              props: exit,
              node: node,
              direction: direction
            });
          }
        },
        entry: {
          delay: length / 2
        }
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 5
        }
      }), this.props.children), /*#__PURE__*/_react.default.createElement(_.TransitionPortal, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110,
          columnNumber: 5
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-cover-el",
        style: {
          position: "fixed",
          background: this.props.bg || "#4b2571",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          width: "100vw",
          height: "100vh",
          transform: "translateY(100%)"
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 111,
          columnNumber: 6
        }
      })));
    }
  }]);

  return Cover;
}(_react.Component);

exports.default = Cover;